import { render, staticRenderFns } from "./NavigationMobileItem.vue?vue&type=template&id=e712fedc&"
import script from "./NavigationMobileItem.vue?vue&type=script&lang=js&"
export * from "./NavigationMobileItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports